import { PacketDetails } from './../../shared/configuration.model';
import { ConfigurationService } from './../../shared/configuration.service';
import { QATicket, QAResponse, Question } from './../../shared/qaTicket';
import { QuestionService } from './../../shared/questionService';

import { merge as observableMerge, fromEvent as observableFromEvent, BehaviorSubject, Observable } from 'rxjs';

import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PipeTransform } from '@angular/core/src/change_detection/pipe_transform';
import { AuthenticationService } from './../../shared/authentication.service';
import { SuspendedTicket } from './../../shared/qualityticketqueue.model';
import { QualityTicketService } from './../../shared/qualityticketqueue.service';
import { Component, ElementRef, ViewChild, OnInit, forwardRef, ChangeDetectorRef } from '@angular/core';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatTable, ErrorStateMatcher, MatDialog } from '@angular/material';
import { MatSnackBar } from '@angular/material';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';






import { DatePipe } from '@angular/common'
import { TicketService } from '../../shared/ticketService';
import { QACompletedTicket } from '../../shared/qaTicket';
import { Alert } from 'selenium-webdriver';
import { InfodialogComponent } from '../../dialogs/infodialog/infodialog.component';
import { LocalStorage } from '../../shared/localstorage.service';
import { MismatchquestionsinsubmitComponent } from '../../ticket/mismatchquestionsinsubmit/mismatchquestionsinsubmit.component';
import { isNullOrUndefined } from 'util';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
  selector: 'app-viewmytickets',
  templateUrl: './viewmytickets.component.html',
  styleUrls: ['./viewmytickets.component.scss']
})
export class ViewmyticketsComponent implements OnInit {
  public fromdate: Date;
  public todate: Date;
  isDataAvailable = false;
  displayedColumns = ['takenby', 'qualityTicketStart', 'qualityTicketCompletion', 'gcTakenBy', 'ticketNumber', 'viewSummary'];
  dataChange: BehaviorSubject<QACompletedTicket[]> = new BehaviorSubject<QACompletedTicket[]>([]);
  get data(): QACompletedTicket[] { return this.dataChange.value; }
  dataSource: ConfigurationDataSource | null;
  public errormessage: string | null;
  qaTicket = new QATicket();
  ticketResponses = new Array<QAResponse>();
  ticketQuestions = new Array<Question>();
  excavator = new Array<QAResponse>();
  notification = new Array<QAResponse>();
  location = new Array<QAResponse>();
  remarks = new Array<QAResponse>();
  map = new Array<QAResponse>();
  end = new Array<QAResponse>();
  mismatchQuestions = new Array<QAResponse>();
  criticalLevel: string = '';
  queueCategory: string = '';
  ticketNumber: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filter: ElementRef;

  updateLockRow: QACompletedTicket[] = [];
  private category: string;
  packets: PacketDetails[] = [];
  packetId: number;

  constructor(private qualityQueueService: QualityTicketService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private auth: AuthenticationService,
    public router: Router,
    public route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public ticketService: TicketService,
    public datepipe: DatePipe,
    private questionService: QuestionService,
    private localStorage: LocalStorage,
    private configurationService: ConfigurationService) {
  }

  startDate = new FormControl('', [Validators.required]);
  endDate = new FormControl('', [Validators.required]);

  matcher = new MyErrorStateMatcher();

  populateConfigurationQueue() {
    if (!isNullOrUndefined(this.auth.fromDateSearch) && this.auth.fromDateSearch !== ''
      && !isNullOrUndefined(this.auth.toDateSearch) && this.auth.toDateSearch !== '') {
      this.fromdate = new Date(this.auth.fromDateSearch);
      this.todate = new Date(this.auth.toDateSearch);
      this.criticalLevel = this.auth.criticalLevelSearch;
      this.queueCategory = this.auth.queueCategorySearch;
      this.searchClick('', new Date(this.auth.fromDateSearch), new Date(this.auth.toDateSearch), this.auth.criticalLevelSearch,
        this.auth.queueCategorySearch, this.packetId);
    }
    else {
      this.ticketService.getMyTickets(this.auth.username, this.auth.currentState).subscribe(rcgitems => {
        if (rcgitems !== null) {
          this.dataChange.next(rcgitems);
          this.isDataAvailable = true;
          this.cdRef.detectChanges();
          this.initSource();
        }
      });
    }
  }


  ngOnInit() {
    this.populateConfigurationQueue();
    this.configurationService.getPackages(this.auth.currentState).subscribe((res: PacketDetails[]) => {
      this.packets = res;
    });
  }

  initSource() {
    this.dataSource = new ConfigurationDataSource(this, this.paginator, this.sort);
    observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged())
      .subscribe(() => {
        if (!this.dataSource) { return; }
        this.dataSource.filter = this.filter.nativeElement.value;
      });
    this.cdRef.detectChanges();


  }

  searchClick(ticketNumber: string, startDateSearch: Date, endDateSearch: Date, criticalLevel: string, queueCategory: string, packetId: number) {
    if (ticketNumber) {
      this.ticketService.getMyTicketsSearch(this.auth.username, ticketNumber, '', '', '', '', 0, this.auth.currentState).subscribe(rcgitems => {
        if (rcgitems != null) {
          this.dataChange.next(rcgitems);
          this.isDataAvailable = true;
          this.cdRef.detectChanges();
          this.initSource();
        }
      });
    }
    else {
      if (startDateSearch == null && endDateSearch == null) {
        this.startDate.invalid;
        this.endDate.invalid;
        this.startDate.markAsDirty();
        this.endDate.markAsDirty();
        this.errormessage = "This field is required";
        return;
      }
      else if (startDateSearch == null) {
        this.startDate.invalid;
        this.errormessage = "This field is required";
        return this.startDate.markAsDirty();
      }
      else if (endDateSearch == null) {
        this.endDate.invalid;
        this.errormessage = "This field is required";
        return this.endDate.markAsDirty();
      }

      else {

        var startDateForDateDiff = new Date(this.datepipe.transform(startDateSearch, 'MM/dd/yyyy'));
        var endDateForDateDiff = new Date(this.datepipe.transform(endDateSearch, 'MM/dd/yyyy'));
        var startDateForApi = this.datepipe.transform(startDateSearch, 'MM/dd/yyyy');
        var endDateForApi = this.datepipe.transform(endDateSearch, 'MM/dd/yyyy');
        this.auth.fromDateSearch = startDateSearch.toString();
        this.auth.toDateSearch = endDateSearch.toString();
        var dateDifference = Math.abs(startDateForDateDiff.getTime() - endDateForDateDiff.getTime());
        var diffDays = Math.ceil(dateDifference / (1000 * 3600 * 24));
        if (diffDays >= 30) {
          let dialogRef = this.dialog.open(InfodialogComponent, {
            width: '600px',
            data: {
              title: 'Alert',
              content: 'You can search for durations only up to 30 days.'
            }
          });

          return;

        }
        else {
          this.ticketService.getMyTicketsSearch(this.auth.username, '', startDateForApi, endDateForApi, criticalLevel, queueCategory, packetId, this.auth.currentState).subscribe(rcgitems => {
            if (rcgitems != null) {
              this.dataChange.next(rcgitems);
              this.isDataAvailable = true;
              this.cdRef.detectChanges();
              this.initSource();
            }
          });
        }
      }
    }
    this.auth.criticalLevelSearch = criticalLevel;
    this.auth.queueCategorySearch = queueCategory;
  }

  clearSearch() {
    this.auth.fromDateSearch = '';
    this.auth.toDateSearch = '';
    this.auth.criticalLevelSearch = '';
    this.auth.queueCategorySearch = '';
    this.fromdate = null;
    this.todate = null;
    this.criticalLevel = '';
    this.queueCategory = '';
    this.packetId = 0;
    this.ticketNumber = '';
    this.populateConfigurationQueue();
  }

  clearCriticalLevel() {
    this.criticalLevel = '';
    this.auth.criticalLevelSearch = '';
  }

  clearQueueCategory() {
    this.queueCategory = '';
    this.auth.queueCategorySearch = '';
  }

  clearPacket() {
    this.packetId = 0;
  }

  viewSummary(ticketNumber: string) {
    this.mismatchQuestions = new Array<QAResponse>();
    this.questionService.getQATicket(ticketNumber, this.localStorage.getItem('currentState')).then(data => {
      if (data.QATicket != null) {
        this.qaTicket = data.QATicket;
        this.ticketQuestions = data.TicketQuestions;
        this.qaTicket.Response.forEach(response => {
          const question = this.ticketQuestions.find(x => x.ID === response.QuestionID);
          response.QuestionText = question.QuestionText;
          response.Section = question.Section;
          response.CanNA = question.CanNA;
          response.ValidResponse = question.ValidResponse;

          if (response.ResponseValue !== 'na') {
            if (response.ResponseValue !== response.ValidResponse && response.ValidResponse !== 'multiresponses') {
              this.mismatchQuestions.push(response);
            }

            if (response.ValidResponse === 'multiresponses') {
              if (response.CriticalLevel < 0) {
                this.mismatchQuestions.push(response);
              }
            }
          }
        });
        let mismatchquestionsdialog = this.dialog.open(MismatchquestionsinsubmitComponent, {
          width: '600px',
          data: {
            questions: this.mismatchQuestions,
            submit: false
          }
        });
      }
    });
  }
}



export class ConfigurationDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  dataChange: BehaviorSubject<QACompletedTicket[]> = new BehaviorSubject<QACompletedTicket[]>([]);
  get data(): QACompletedTicket[] { return this.dataChange.value; }

  filteredData: QACompletedTicket[] = [];
  renderedData: QACompletedTicket[] = [];

  constructor(private rcgcomponent: ViewmyticketsComponent,
    private _paginator: MatPaginator,
    private _sort: MatSort) {
    super();

    this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<QACompletedTicket[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.rcgcomponent.dataChange,
      this._sort.sortChange,
      this._filterChange,
      this._paginator.page,
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      // Filter data

      this.filteredData = this.rcgcomponent.data.slice().filter((item: QACompletedTicket) => {
        const searchStr = (item.QualityCompletedBy + item.GCTicketTakenBy + item.GCTicketNumber).toLowerCase();
        return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
      });


      // Sort filtered data
      const sortedData = this.sortData(this.filteredData.slice());

      // Grab the page's slice of the filtered sorted data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
      return this.renderedData;

    }));

  }

  disconnect() { }

  /** Returns a sorted copy of the database data. */
  sortData(data: QACompletedTicket[]): QACompletedTicket[] {
    if (!this._sort.active || this._sort.direction === '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'takenby': [propertyA, propertyB] = [a.QualityCompletedBy, b.QualityCompletedBy]; break;
        case 'gcTakenBy': [propertyA, propertyB] = [a.GCTicketTakenBy, b.GCTicketTakenBy]; break;
        case 'ticketNumber': [propertyA, propertyB] = [a.GCTicketNumber, b.GCTicketNumber]; break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}